import Box from "@cloudscape-design/components/box"
import Button from "@cloudscape-design/components/button"
import FormField from "@cloudscape-design/components/form-field"
import Input from "@cloudscape-design/components/input"
import Modal from "@cloudscape-design/components/modal"
import SpaceBetween from "@cloudscape-design/components/space-between"
import { useState } from "react"

interface AmendDtaModalProps {
  /**
   * Display name of the DTA being amended (shown in the modal body).
   */
  dtaName: string
  /**
   * Whether the amend request is in flight.
   */
  loading: boolean
  /**
   * Called with the entered change reason when the user confirms.
   */
  onConfirm: (changeReason: string) => void
  /**
   * Called when the user dismisses or cancels the modal.
   */
  onClose: () => void
}

/**
 * Modal prompting the DAE for a change reason before creating a new DTA version (amendment).
 */
const AmendDtaModal = ({ dtaName, loading, onConfirm, onClose }: AmendDtaModalProps) => {
  const [reason, setReason] = useState("")

  return (
    <Modal
      visible
      onDismiss={onClose}
      header="Amend Data Transfer Agreement"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              loading={loading}
              disabled={!reason.trim()}
              onClick={() => onConfirm(reason.trim())}
            >
              Create Amendment
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Box>
          Create a new version of <b>{dtaName}</b>. The current content will be preserved as a
          snapshot.
        </Box>
        <FormField label="Reason for amendment">
          <Input
            value={reason}
            placeholder="e.g., Protocol Amendment 3"
            autoFocus
            onChange={({ detail }) => setReason(detail.value)}
          />
        </FormField>
      </SpaceBetween>
    </Modal>
  )
}

export default AmendDtaModal
